export const ATTRIBUTION_COOKIE_NAME = 'f_attr';
export const ATTRIBUTION_COOKIE_KEYS = {
  utmCampaign: 'utm_campaign',
  utmContent: 'utm_content',
  utmMedium: 'utm_medium',
  utmSource: 'utm_source',
  utmTerm: 'utm_term',
  googleClientId: 'google_client_id',
  referrer: 'referrer',
} as const;

export const ATTRIBUTION_COOKIE_PAID_NAME = 'p_attr';
export const ATTRIBUTION_COOKIE_PAID_KEYS = {
  gClid: 'gclid',
  bingClkid: 'msclkid',
  hsAmt: 'hsa_mt',
} as const;

export const AFFILIATE_COOKIE_NAME = 'f_aff';
export const AFFILIATE_COOKIE_KEY = 'affiliate';

export const DEBUGGER_COOKIE_NAME = 'front_debug';

export const HUBSPOT_HUTK_COOKIE_NAME = 'hubspotutk';
